<div class="igo-home-extent-button-container">
  <button
    mat-icon-button
    [matTooltip]="'igo.geo.mapButtons.home-extent' | translate"
    matTooltipPosition="left"
    [color]="color()"
    (click)="onToggleClick()"
  >
    <mat-icon>home</mat-icon>
  </button>
</div>
